import React, { FC } from 'react';

import clsx from 'clsx';

interface FormErrorFieldProps {
  children: React.ReactNode;
  className?: string;
}

export const FormErrorField: FC<FormErrorFieldProps> = ({
  children,
  className,
}) => {
  return (
    <p
      className={clsx(
        'transition ease-in duration-150 m-0 pt-0 pb-4',
        className,
      )}
    >
      {children}
    </p>
  );
};
